import { api } from '@api'
import type { SetupFilter } from '../filter'
import type { Pagination } from '../index'
import { applyFilters } from '../utils/applyFilters'

export const handleGetTaken = async ({
  filters,
  userId,
  pagination,
}: { filters: SetupFilter; userId: string; pagination: Pagination }) => {
  let query = api()
    .from('taken_setups')
    .select('setup_id, setup_enriched!inner(*)')
    .eq('has_taken', true)
    .eq('user_id', userId)

  query = applyFilters(query, filters, 'setup_enriched')

  if (pagination.limit !== undefined && pagination.offset !== undefined) {
    query = query.range(pagination.offset, pagination.offset + pagination.limit - 1)
  }

  const { data } = await query
  return data?.map(({ setup_enriched }) => setup_enriched) || []
}
